import { request } from "hooks/useOkoApi/useOkoApi";

// A real import with SVG rasterising and image uploads can pass request()'s
// 90 s default, and a retried failure would triple a slow one.
export const IMPORT_TIMEOUT_MS = 5 * 60 * 1000;

export const fetchAdminWarmUpSets = () => request("admin/warm-up-sets", { method: "GET" });

/** Sends the sheet with a 5-minute deadline; answers the import report. */
export const importWarmUpSheet = async (payload) => {
  const deadline = new AbortController();
  const timer = setTimeout(() => deadline.abort(), IMPORT_TIMEOUT_MS);
  try {
    return await request("admin/warm-up-sets/import", {
      method: "POST",
      payload,
      maxRetries: 0,
      signal: deadline.signal,
    });
  } finally {
    clearTimeout(timer);
  }
};

/** Turns one set on or off; answers the set as the list now shows it. */
export const setWarmUpSetActive = (setId, active) =>
  request(`admin/warm-up-sets/${setId}`, { method: "PATCH", payload: { active } });
